export const track = (event, label = "") => {
  try {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ event, label }),
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* never block UI on tracking */
  }
};
